module.exports = __webpack_public_path__ + "media/images/img-unicorn-b039df74252444644c42a1c261a2dfe3.png";